import React from "react";
import { CSVLink } from "react-csv";
// import searchWhiteIcon from "./Icon.png";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import NavBar from "../NavBar";
import { useState } from "react";
import { useEffect } from "react";
export default function InventoryPurchase(props) {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const [type, setType] = useState(0);

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.td8 === 'Purchased'
      } 
      else if (e.target.value === '2') {
        return x.td8 === 'Cancelled'
      }
      else if (e.target.value === '3') {
        return x.td8 === 'In Progress'
      }
    }));  };

      const handle1 = () => {
    setType(0);
  };
  const handle2 = () => {
    setType(1);
  };
  const handle3 = () => {
    setType(2);
  };
  useEffect(() => {
    if (type === 1) {
      setCount(
        IncomingData.filter(
          (x) => x.td8 === "In Progress" 
        )
      );
    } else if (type === 2) {
      setCount(IncomingData.filter((x) => x.td8 === "Cancelled"));
    } else {
      setCount("");
    }
    setFiltr1("");
  }, [type]);


  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="business_title">Inventory Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Purchase</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Purchase</h2>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="order-list-box" style={{ width: "99%" }}>
        <div id="click-data">
          <p onClick={handle1} id={type === 0 ? "clicked-type" : ""}>
           All Products
          </p>
          <p onClick={handle2} id={type === 1 ? "clicked-type" : ""}>
            Overdue
          </p>
          <p onClick={handle3} id={type === 2 ? "clicked-type" : ""}>
            Cancelled
          </p>
        </div>
          <div className="order-list-input-box">
            <div className="order-list-input-left">
              <input
                type="text"
                placeholder="Search by PO number, supplier"
                onChange={(val) => {
                  setCount(
                    IncomingData.filter(
                      (x) =>
                        x.td1.match(val.target.value) ||
                        x.td2.match(val.target.value)
                    )
                  );
                  setFiltr1("");
                }}
              />{" "}
              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr1}
                onChange={handleFilter1}
              >
                <option selected>Order Status</option>
                <option value="1">Purchased</option>
                <option value="2">Cancelled</option>
                <option value="3">In Progress</option>
              </select>
              <CSVLink
                data={IncomingData}
                className="supplier-content-input-right-filters"
                style={{ display: "flex", alignItems: "center" }}
              >
                Explore List
                <OpenInNewIcon
                  style={{ fontSize: "16", marginLeft: "5" }}
                ></OpenInNewIcon>
              </CSVLink>
            </div>
          </div>
          <table style={{ textAlign: "center" }}>
            <tr>
              <th>PO Number</th>
              <th>Supplier</th>
              <th>Item Name</th>
              <th>Delivery Date</th>
              <th>Unit Price</th>
              <th>Qty</th>
              <th>Total Value</th>
              <th id='center'>Order Status</th>
            </tr>
            {count.length > 0
              ? count.map((val) => {
                  return (
                    <tr>
                      <td>{val.td1}</td>
                      <td>{val.td2}</td>
                      <td>{val.td3}</td>
                      <td>{val.td4}</td>
                      <td>{val.td5}</td>
                      <td>{val.td6}</td>
                      <td>{val.td7}</td>
                      <td
                       className="col-status"
                      id={
                        val.td8 === "Purchased"
                          ? "col-green"
                          : val.td8 === "Cancelled"
                          ? "col-red"
                          : val.td8 === "In Progress"
                          ? "col-yellow"
                          : ""
                      }
                      >{val.td8}</td>
                    </tr>
                  );
                })
              : IncomingData.map((val) => {
                  return (
                    <tr>
                      <td>{val.td1}</td>
                      <td>{val.td2}</td>
                      <td>{val.td3}</td>
                      <td>{val.td4}</td>
                      <td>{val.td5}</td>
                      <td>{val.td6}</td>
                      <td>{val.td7}</td>
                      <td className="col-status"
                      id={
                        val.td8 === "Purchased"
                          ? "col-green"
                          : val.td8 === "Cancelled"
                          ? "col-red"
                          : val.td8 === "In Progress"
                          ? "col-yellow"
                          : ""
                      }
                      >{val.td8}</td>
                    </tr>
                  );
                })}
          </table>
        </div>
      </div>
    </>
  );
}
export const IncomingData = [
  {
    td1: "KCVF1211",
    td2: "Niel",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Cancelled",
  },
  {
    td1: "KCVF12555",
    td2: "Joe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF1266L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "In Progress",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Cancelled",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "In Progress",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
  {
    td1: "KCVF12L",
    td2: "John Doe",
    td3: "Nike shoes air zoom for men",
    td4: "01-01-2022",
    td5: 995,
    td6: 15,
    td7: 9995,
    td8: "Purchased",
  },
];
